<template>
    <el-dialog
        :title="title"
        width="400px"
        :visible.sync="visible"
        :close-on-click-modal="false"
        :before-close="close">
        <el-form v-if="visible" :model="form" :rules="rules" label-width="100px" ref="formRef">
            <el-form-item label="股东姓名" prop="shareholderName">
                <el-input v-model.trim="form.shareholderName" clearable></el-input>
            </el-form-item>
            <el-form-item label="身份证" prop="idCard">
                <el-input v-model.trim="form.idCard" clearable></el-input>
            </el-form-item>
            <el-form-item label="是否内部员工" prop="isInternalStaff">
                <el-select v-model="form.isInternalStaff" clearable placeholder="请选择" class="select">
                    <el-option label="是" value="是"></el-option>
                    <el-option label="否" value="否"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="持股比例" prop="shareholdingRatio">
                <el-input v-model.trim="form.shareholdingRatio" clearable></el-input>
            </el-form-item>
            <el-form-item label="关联公司" prop="relateCompanyName">
                <el-input v-model.trim="form.relateCompanyName" clearable></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" :loading="loading" @click="save">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import Decimal from 'decimal.js';
import { addShareholder, editShareholder } from '../../../../../../api/shareholder.js';

const INIT_FORM = {
    shareholderName: '',
    idCard: '',
    isInternalStaff: '',
    shareholdingRatio: '',
    relateCompanyName: '',
}

export default {
    props: {
        supplierTab: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            visible: false,
            loading: false,
            form: { ...INIT_FORM },
            rules: {
                shareholderName: [
                    { required: true, message: '请输入股东姓名', trigger: ['blur', 'change'] },
                    { max: 200, message: '不能超过200个字符', trigger: ['blur', 'change'] }
                ],
                idCard: [
                    { required: true, message: '请输入身份证', trigger: ['blur', 'change'] },
                    { pattern: /^[0-9a-zA-Z]{1,50}$/, message: '请输入50位以内的数字字母', trigger: ['blur', 'change'] }
                ],
                shareholdingRatio: [
                    {
                        validator: (rule, value, callback) => {
                            if (['', undefined, null].includes(value)) {
                                callback();
                            } else if (!/^\d+(\.\d{1,2})?$/.test(value) || Number(value) < 0 || Number(value) > 1) {
                                callback(new Error('只能输入数字，范围0.01-1'));
                            } else {
                                callback();
                            }
                        },
                        trigger: ['blur', 'change']
                    }
                ],
                relateCompanyName: [{ max: 200, message: '不能超过200个字符', trigger: ['blur', 'change'] }],
            },
            currentId: null,
            currentVersion: null,
        };
    },
    computed: {
        title() {
            return this.currentId ? '编辑' : '新增'
        }
    },
    methods: {
        open(row) {
            if (row) {
                this.currentId = row.id
                this.currentVersion = row.version
                this.form.shareholderName = row.shareholderName
                this.form.idCard = row.idCard
                this.form.isInternalStaff = row.isInternalStaff
                this.form.shareholdingRatio = row.shareholdingRatio ? Decimal(row.shareholdingRatio.replace('%', '')).div(100).valueOf() : ''
                this.form.relateCompanyName = row.relateCompanyName
            }
            this.visible = true
        },
        close() {
            this.currentId = null
            this.currentVersion = null
            this.form = { ...INIT_FORM }
            this.$nextTick(() => {
                this.$refs.formRef.clearValidate();
                this.visible = false
            });
        },
        save() {
            this.$refs.formRef.validate(valid => {
                if (valid) {
                    this.loading = true
                    const apiFunc = this.currentId ? editShareholder : addShareholder
                    apiFunc(this.getParams()).then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success(`${this.title}成功!`)
                            this.$emit('refresh')
                            this.close()
                        }
                    }).finally(() => { this.loading = false })
                }
            })
        },
        getParams() {
            const params = { ...this.form, supplierCode: this.supplierTab.supplierCode }
            if (this.currentId) {
                params.id = this.currentId
                params.version = this.currentVersion
            }
            return params
        },
    }
};
</script>
<style lang="less" scoped>
.select {
    width: 100%;
}
</style>